import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Form, Button } from 'react-bootstrap';
import { AgGridReact } from 'ag-grid-react';
import axios from 'axios';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const Shipping = () => {
    const [rowData, setRowData] = useState([]);
    const [columnDefs] = useState([
        {
            field: 'grupo',
            headerName: 'GRUPO',
            sortable: true,
            filter: true,
            editable: true,
            minWidth: 350
        },
        {
            field: 'sku',
            headerName: 'SKU',
            sortable: true,
            filter: true,
            editable: true
        },
        {
            field: 'qtde_pallet',
            headerName: 'QTDE PALLET',
            sortable: true,
            filter: true,
            editable: true,
            valueFormatter: params => params.value ? Number(params.value).toFixed(2) : '0.00'
        },
        {
            field: 'net',
            headerName: 'NET',
            sortable: true,
            filter: true,
            editable: true,
            valueFormatter: params => params.value ? Number(params.value).toFixed(2) : '0.00'
        },
        {
            field: 'descricao',
            headerName: 'DESCRIÇÃO',
            sortable: true,
            filter: true,
            editable: true,
            minWidth: 250
        },
        {
            field: 'mes_ex',
            headerName: 'MÊS',
            sortable: true,
            filter: true,
            editable: true
        },
        {
            field: 'uf_frete',
            headerName: 'UF FRETE',
            sortable: true,
            filter: true,
            editable: true
        },
        {
            field: 'val_frete',
            headerName: 'VALOR FRETE',
            sortable: true,
            filter: true,
            editable: true,
            minWidth: 110,
            valueFormatter: params => formatCurrency(params.value),
           
        }
    ]);
    const [filterText, setFilterText] = useState("");
    const [selectedMonth, setSelectedMonth] = useState("");
    const [showTable, setShowTable] = useState(false);
    const [routes, setRoutes] = useState([]);
    const [selectedRoute, setSelectedRoute] = useState("");

    useEffect(() => {
        const fetchRoutes = async () => {
            try {
                const response = await axios.post('https://back.bidolux.jmatecnologia.inf.br/api/get-routes', {}, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
                setRoutes(response.data);
            } catch (error) {
                console.error('Erro ao buscar rotas:', error);
            }
        };
    
        fetchRoutes();
    }, []);

    const formatCurrency = (value) => {
        if (!value) return 'R$ 0,00';
        return `R$ ${parseFloat(value).toFixed(2).replace('.', ',')}`;
    };

    const handleSearch = async () => {
        // const date = new Date(selectedMonth);
        // const monthNames = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 
        //                   'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
        
        // const month = selectedMonth ? parseInt(selectedMonth.split('-')[1]) : null;
        // const year = selectedMonth ? date.getFullYear() : null;
        // const formattedMonth = month ? `${monthNames[month - 1]} ${year}` : null;
    
        try {
            const response = await axios.get('https://back.bidolux.jmatecnologia.inf.br/api/fretes/search', {
                params: {
                    produto: filterText || '',
                    mes: selectedMonth || '', 
                    rota: selectedRoute || ''
                }
            });
    
            setRowData(response.data);
            setShowTable(true);
        } catch (error) {
            console.error('Erro:', error);
            setShowTable(false);
        }
    };

    const handleClear = () => {
        setFilterText("");
        setSelectedMonth("");
        setSelectedRoute("");
        setShowTable(false);
        setRowData([]);
    };

    const handleCellValueChanged = async (event) => {
        const { data, colDef, newValue } = event;
        const field = colDef.field;
    
        try {
            await axios.put(`https://back.bidolux.jmatecnologia.inf.br/api/fretes/update/${data.id}`, {
                [field]: newValue
            });
            console.log(`Campo "${field}" atualizado com sucesso:`, newValue);
        } catch (error) {
            console.error('Erro ao salvar atualização:', error);
        }
    };

    return (
        <Container fluid className="py-4">
            <Row>
                <Col>
                    <Card>
                        <Card.Header>
                            <Card.Title>Gerenciamento de Fretes</Card.Title>
                        </Card.Header>
                        <Card.Body>
                            <Row className="mb-3">
                                <Col md={3}>
                                    <Form.Control
                                        placeholder="Pesquisar SKU"
                                        value={filterText}
                                        onChange={(e) => setFilterText(e.target.value)}
                                    />
                                </Col>
                                <Col md={3}>
                                    <Form.Control
                                        type="month"
                                        value={selectedMonth}
                                        onChange={(e) => setSelectedMonth(e.target.value)}
                                    />
                                </Col>
                                <Col md={4}>
                                    <Form.Select
                                        value={selectedRoute}
                                        onChange={(e) => setSelectedRoute(e.target.value)}
                                    >
                                        <option value="">Selecione uma rota</option>
                                        {routes.map(route => (
                                            <option key={route.id} value={route.id}>
                                                {`${route.state_from.toUpperCase()} → ${route.state_to.toUpperCase()}`}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Col>
                                <Col md={2} className="d-flex gap-2">
                                    <Button onClick={handleSearch} variant="primary" className="w-100">
                                        Pesquisar
                                    </Button>
                                    {showTable && (
                                        <Button onClick={handleClear} variant="secondary" className="w-100">
                                            Limpar
                                        </Button>
                                    )}
                                </Col>
                            </Row>

                            {showTable && (
                                <div className="ag-theme-alpine w-100" style={{ height: '600px' }}>
                                    <AgGridReact
                                        rowData={rowData}
                                        columnDefs={columnDefs}
                                        defaultColDef={{
                                            flex: 1,
                                            minWidth: 120,
                                            suppressMovable: true
                                        }}
                                        onCellValueChanged={handleCellValueChanged}
                                    />
                                </div>
                            )}
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default Shipping;